// import * as actionTypes from './constants';
// import { updateObject } from '../../shared/utility';

// const initialState = {
//     isInitiated: false,
//     isSuccess: false,
//     isFailed: false,
//     errorMessage: false,
//     jobList: [],
//     searchParams: null,
//     searchedJobList: []
// }

// const jobListRequestInitiated = (state) => {
//     return updateObject(state, {
//         isInitiated: true,
//         isSuccess: false,
//         isFailed: false,
//         errorMessage: false
//     });
// }
// const jobListRequestSuccess = (state, action) => {
//     return updateObject(state, {
//         isInitiated: false,
//         isSuccess: true,
//         jobList: [...action.data ],
//         isFailed: false,
//         errorMessage: false,
//         searchParams: action.searchParams
//     });
// }
// const jobListRequestFailed = (state, action) => {
//     return updateObject(state, {
//         isInitiated: false,
//         isSuccess: false,
//         isFailed: true,
//         errorMessage: action.payload
//     });
// }

// const searchJobListRequestInitiated = (state) => {
//     return updateObject(state, {
//         isInitiated: true,
//         isSuccess: false,
//         isFailed: false,
//         errorMessage: false
//     });
// }
// const searchJobListRequestSuccess = (state, action) => {
//     return updateObject(state, {
//         isInitiated: false,
//         isSuccess: true,
//         searchedJobList: [...action.data ],
//         isFailed: false,
//         errorMessage: false,
//         searchParams: action.searchParams
//     });
// }
// const searchJobListRequestFailed = (state, action) => {
//     return updateObject(state, {
//         isInitiated: false,
//         isSuccess: false,
//         isFailed: true,
//         errorMessage: action.payload
//     });
// }

// const reducer = (state = initialState, action) => {
//     switch (action.type) {
//         case actionTypes.JOB_LIST_REQUEST_INITIATED: return jobListRequestInitiated(state, action);
//         case actionTypes.JOB_LIST_REQUEST_SUCCESS: return jobListRequestSuccess(state, action)
//         case actionTypes.JOB_LIST_REQUEST_FAILED: return jobListRequestFailed(state, action)
//         case actionTypes.SEARCH_JOB_LIST_REQUEST_INITIATED: return searchJobListRequestInitiated(state, action);
//         case actionTypes.SEARCH_JOB_LIST_REQUEST_SUCCESS: return searchJobListRequestSuccess(state, action)
//         case actionTypes.SEARCH_JOB_LIST_REQUEST_FAILED: return searchJobListRequestFailed(state, action)
//         default:
//             return state;
//     }
// }

// export default reducer;

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isInitiated: false,
	isSuccess: false,
	isFailed: false,
	errorMessage: false,
	jobList: [],
	searchParams: null,
	searchedJobList: [],
};

const jobSlice = createSlice({
	name: 'job',
	initialState,
	reducers: {
		jobListRequestInitiated: state => {
			state.isInitiated = true;
			state.isSuccess = false;
			state.isFailed = false;
			state.errorMessage = false;
		},
		jobListRequestSuccess: (state, action) => {
			state.isInitiated = false;
			state.isSuccess = true;
			state.jobList = [...action.payload.data];
			state.isFailed = false;
			state.errorMessage = false;
			state.searchParams = action.payload.searchParams;
		},
		jobListRequestFailed: (state, action) => {
			state.isInitiated = false;
			state.isSuccess = false;
			state.isFailed = true;
			state.errorMessage = action.payload;
		},
		searchJobListRequestInitiated: state => {
			state.isInitiated = true;
			state.isSuccess = false;
			state.isFailed = false;
			state.errorMessage = false;
		},
		searchJobListRequestSuccess: (state, action) => {
			state.isInitiated = false;
			state.isSuccess = true;
			state.searchedJobList = [...action.payload.data];
			state.isFailed = false;
			state.errorMessage = false;
			state.searchParams = action.payload.searchParams;
		},
		searchJobListRequestFailed: (state, action) => {
			state.isInitiated = false;
			state.isSuccess = false;
			state.isFailed = true;
			state.errorMessage = action.payload;
		},
	},
});

export const {
	jobListRequestInitiated,
	jobListRequestSuccess,
	jobListRequestFailed,
	searchJobListRequestInitiated,
	searchJobListRequestSuccess,
	searchJobListRequestFailed,
} = jobSlice.actions;
export default jobSlice.reducer;
